import { TitledSitecoreItem } from '../types/sitecore';

export const getTitle = <T>(item: TitledSitecoreItem<T>): string | undefined => {
  const itemTitle = item.fields.Title;
  const itemTitleDictionary = item.fields.TitleDictionary;

  if (itemTitle?.value) {
    return itemTitle.value as string;
  }

  if (!itemTitleDictionary?.fields) {
    return undefined;
  }

  return itemTitleDictionary.fields.Phrase
    ? itemTitleDictionary.fields.Phrase.value
    : itemTitleDictionary.fields.PhraseShared.value;
};
